/* biome-ignore-all lint/suspicious/noExplicitAny: legacy data structure */
import { HttpRequest } from "@/utils/request"

export interface SettingItem {
  id: number
  group: string
  name: string
  locked: number
  payload: any
  created_at: string
  updated_at: string
  set_items?: any[]
}

export interface SettingListResponse {
  code: number
  message: string
  data: SettingItem[]
  paginate: {
    total: number
    page: number
    limit: number
  }
  groups: string[]
}

export interface SettingDetailResponse {
  code: number
  message: string
  data: SettingItem
}

export const settingService = {
  list(params: { page?: number; limit?: number; group?: string; search?: string }) {
    return HttpRequest.get("v1/settings", {
      searchParams: params as any,
    }).json<SettingListResponse>()
  },

  get(id: number) {
    return HttpRequest.get(`v1/settings/${id}`).json<SettingDetailResponse>()
  },

  create(data: { group: string; name: string; payload: any; locked?: number }) {
    return HttpRequest.post("v1/settings", {
      json: data,
    }).json<{
      code: number
      message: string
      data: SettingItem
    }>()
  },

  update(id: number, data: { payload?: any; locked?: number }) {
    return HttpRequest.put(`v1/settings/${id}`, {
      json: data,
    }).json<{
      code: number
      message: string
      data: SettingItem
    }>()
  },

  delete(id: number) {
    return HttpRequest.delete(`v1/settings/${id}`).json<{
      code: number
      message: string
    }>()
  },
}
